/* tutor-1 (C): "ESTE ARCHIVO ES MUY GRANDE PARA EL TUTOR": la ventana de la casa (480) con "Subirlo al Panel" (se va al
   Panel con ese mismo archivo ya elegido) y "Elegir otro archivo" (abre el selector otra vez).

   ARCHIVO EN ASCII A PROPOSITO. */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Ventana, { BOTON_VENTANA_PRINCIPAL, BOTON_VENTANA_SECUNDARIO } from '../alumno/Ventana';

export default function VentanaArchivoGrande({ alSubirAlPanel, alElegirOtro, alCerrar }) {
  const { t } = useTranslation('study');
  return (
    <Ventana titulo={t('tutor.big.title')} ancho={480} alCerrar={alCerrar} testid="tutor-archivo-grande" etiquetaId="tutor-archivo-grande-titulo"
      botones={(
        <>
          <button type="button" className={BOTON_VENTANA_SECUNDARIO} onClick={alElegirOtro} data-testid="tutor-archivo-grande-otro">
            {t('tutor.big.other')}
          </button>
          <button type="button" className={BOTON_VENTANA_PRINCIPAL} onClick={alSubirAlPanel} data-testid="tutor-archivo-grande-panel">
            {t('tutor.big.upload')}
          </button>
        </>
      )}>
      <p className="m-0 text-[14px] leading-[1.55] text-[#C8C8C8]">{t('tutor.big.body')}</p>
    </Ventana>
  );
}
